
































import Vue from 'vue';
import Component from 'vue-class-component';
import * as Logger from 'js-logger';
import { debounce } from 'ts-debounce';
import UserPicker from '@/components/user-picker.vue';
import { IPickUser } from '@/models/pick-user';
import UserDetails from '@/components/user/details.vue';

Logger.useDefaults();
const log = Logger.get('User');
if (process.env.NODE_ENV !== 'production') {
  log.setLevel(log.DEBUG);
}

interface IPoint {
  x: number;
  y: number;
}

@Component({
  components: { UserPicker, UserDetails }
})
export default class User extends Vue {
  name = '';
  email = '';
  usersByEmail = [];
  usersByName = [];
  userPickerX = 0;
  userPickerY = 0;

  pickedUser: IPickUser | null = null;

  created() {
    this.onNameChange = debounce(this.onNameChange, 100);
    this.onEmailChange = debounce(this.onEmailChange, 100);
  }

  getBottomLeft(elementName: string): IPoint {
    const el = ((this.$refs[elementName]) as Vue).$el;
    const rect = el.getBoundingClientRect();
    return {
      x: rect.left,
      y: rect.bottom
    }
  }

  async onNameChange() {
    if (this.name.length === 0) {
      this.usersByName = [];
    } else {
      this.usersByName = await this.$api.get(`/api/user/search/name/${this.name}`);
      log.info('Fetched users', this.usersByName);
      const point = this.getBottomLeft('name');
      this.userPickerY = point.y;
      this.userPickerX = point.x;
    }
  }

  onEmailChange() {
  }

  userPicked(user: IPickUser) {
    this.$router.push({
      'name': 'db-users-detail',
      params: {
        'userId': user.id as unknown as string
      }
    });
    this.pickedUser = user;
    this.usersByName = [];
  }
}
